import {
  Injectable,
} from '@angular/core';
import { EMPTY, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

interface AuthObj {
  only?: string[];
  except?: string[];
}

@Injectable({ providedIn: 'root' })
export class ZefPermissionService {
  private _store: Record<string, () => Observable<boolean>> = {};

  define(name: string, validation: () => Observable<boolean>): void {
    this._store[name] = validation;
  }

  authorize(authObj: AuthObj): Observable<boolean> {
    if (authObj.only && authObj.except) {
      throw new Error('Authorization object cannot contain both [only] and [except]');
    }

    if (authObj.only) {
      return this._checkAuthorization(authObj.only, 'only');
    }

    if (authObj.except) {
      return this._checkAuthorization(authObj.except, 'except');
    }

    throw new Error('Authorization object must contain either [only] or [except]');
  }

  private _checkAuthorization(names: string[], type: 'only' | 'except'): Observable<boolean> {
    const mergeObsrArr: Array<Observable<boolean>> = [];

    names.forEach((res: string) => {
      if (this._store[res]) {
        mergeObsrArr.push(this._store[res].call(this));
      } else {
        console.warn(`Permission: No defined validation for ${res}`);
      }
    });

    return combineLatest([ ...mergeObsrArr ]).pipe(
      map((res: boolean[]) => {
        const r = res.some((x) => x === true);
        if (type === 'only') {
          return !!r;
        }
        if (type === 'except') {
          return !r;
        }
        return false;
      })
    );
  }
}
